import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=3a434f36"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=3a434f36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports